export class BaseEnumEx {
    public static toDisplay(enumValue: any) {
        return 'Unknown'
    }
    public static toDisplayPlural(enumValue: any) {
        return 'Unknowns'
    }
}
